module.exports = __webpack_public_path__ + "static/media/606.26018e15.webp";